<template>
    <div class="subject">
        <div class="subject-head">
            <span class="sub-blue">{{index}}、</span>
            <div class="subject-head-t sub-blue">{{data.categories_name}}</div>
            <div v-if="data.categories!=4"><span v-html="HTMLEncodes(data.question)"></span>（{{data.pivot.score}}分）</div>
            <!-- 填空 -->
            <!-- <div v-else><span @input="data.resultValue=$event.target.value" contenteditable="true" v-html="setInputHtml(data.question)"></span>（{{data.pivot.score}}分）</div> -->
            <div v-else><span v-html="HTMLEncodes(data.question).split('（）')[0]"></span> (<input class="subject-head-input outline" v-model="data.resultValue" />) <span v-html="HTMLEncodes(data.question).split('（）')[1]"></span>（{{data.pivot.score}}分）</div>
        </div>
        <div class="subject-topic">
            <!-- 单选 -->
            <el-radio-group v-if="data.categories === 1 || data.categories === 3" v-model="radio" text-color="#4D8EF6" @change="(v)=>data.resultValue=v">
                <el-radio v-for="(item,key,index) in data.select" :key="index"  :label="key">{{data.categories === 1 ? key : ''}} {{item}}</el-radio>
            </el-radio-group>
            <!-- 多选 -->
            <el-checkbox-group v-if="data.categories === 2" v-model="checkList" @change="(v)=>data.resultValue=v">
                <el-checkbox v-for="(item, key, index) in data.select" :key="index" :label="key">{{key}} {{item}}</el-checkbox>
            </el-checkbox-group>
            <!-- 简答 -->
            <div v-if="data.categories === 5" style="margin-top:20px;margin-left:26px;">
                <textarea v-model="data.resultValue" autocomplete="off" rows="10" placeholder="請簡述妳的答案..." class="el-textarea__inner" style="min-height: 33px;">
                </textarea>
            </div>
        </div>
        <slot></slot>
    </div>
</template>
<script>
import { HTMLEncode } from '@/utils'
export default {
    data(){
        return {
            radio: '',
            checkList:[],
            textarea:'',
            gap:'',         
        }
    },
    props:{
        data: {
            type: [Object,String],
            default:function(v){
                return ''
            }
        },
        index: {
            type: [String, Number],
        },
    },
    created(){
    },
    methods:{
        HTMLEncodes(v){
            return HTMLEncode(v); 
        },
        //设置input
        setInputHtml (val) {
            if (val.indexOf('（）') !== -1) {
                // var value=val.split('（）');
                return val.replace('（）', ' (<input class="subject-head-input outline" />) ')
            } else {
                return val
            }
        },
        handleCheckedCitiesChange(v){
        },
    }
}
</script>
<style scoped>
.el-radio, .el-radio__input{
    white-space: inherit;
    display: flex;
}
</style>
<style lang="less">
@blue:#4D8EF6;
.sub-blue{
    color:@blue
}
.el-radio-group,.el-checkbox-group{
    display: flex;
    flex-flow: column;
    padding-left: 26px;
    label{
        margin-top: 20px;
    }
}
.subject{
    font-size: 14px;
    color:rgba(51,51,51,1);
    &-head{
        display: flex;
        align-items: center;
        font-size:14px;
        &-t{
            border:1px solid @blue;
            padding: 6px 10px;
            border-radius: 4px;
            margin-left: 6px;
            margin-right: 13px;
            // width: 56px;
            box-sizing: border-box;
            text-align: center;
            white-space: nowrap;
        }
        &-input{
            border: none;
            padding: 0 10px;
            width: 20px;
            min-width: 60px;
        }
    }
}
</style>